import React from "react"

export default function ArrowRight() {
   return (
      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
         <g clipPath="url(#clip0_171_8913)">
            <path d="M16.7301 13.461L9.89766 20.2934C9.56814 20.6229 9.0339 20.6229 8.70442 20.2934L7.90753 19.4965C7.57857 19.1675 7.57794 18.6344 7.90613 18.3047L13.3209 12.8644L7.90613 7.42413C7.57794 7.0944 7.57857 6.56125 7.90753 6.23229L8.70442 5.43541C9.03394 5.10589 9.56817 5.10589 9.89766 5.43541L16.7301 12.2677C17.0595 12.5973 17.0595 13.1315 16.7301 13.461Z" fill="#B8BAC2" />
         </g>
         <defs>
            <clipPath id="clip0_171_8913">
               <rect width="15.75" height="18" fill="white" transform="matrix(0 -1 1 0 3.3186 20.7393)" />
            </clipPath>
         </defs>
      </svg>
   )
}